import styled from '@emotion/styled';
import React from 'react';
import {useTranslation} from 'react-i18next';

import {mixinSVGIcon} from '@ELib/styles/mixins';

//#region Default EUndecoratedButton
export const EUndecoratedButton = styled(
  (
    props: React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >
  ) => <button type='button' {...props} />,
  {
    shouldForwardProp: (prop: string) =>
      !['inlineText', 'active', 'textColor'].includes(prop),
  }
)<{
  active?: boolean;
  textColor?: boolean;
  inlineText?: boolean;
}>`
  padding: 0;
  border: none;
  background: none;
  width: fit-content;
  cursor: pointer;

  color: ${({textColor}) =>
    textColor ? 'var(--color-core-black)' : 'var(--color-core-link)'};

  font-size: ${({inlineText}) =>
    inlineText ? 'inherit' : 'var(--font-size-small)'};

  font-weight: ${({inlineText}) =>
    inlineText ? 'inherit' : 'var(--font-weight-thin)'};

  ${({active}) => (active ? 'text-decoration: underline;' : '')}

  &:disabled {
    color: var(--color-core-grey);
    cursor: not-allowed;
  }

  svg {
    ${mixinSVGIcon}
  }
`;
//#endregion

//#region ResetFiltersButton
const StyledEResetFiltersButton = styled(EUndecoratedButton)`
  font-weight: var(--font-weight-filter-button);
`;

export const EResetFiltersButton = (props: {
  onClick?: () => void;
}): React.ReactElement => {
  const {t} = useTranslation('lib');
  return (
    <StyledEResetFiltersButton onClick={props.onClick}>
      {t('actions.resetFilters')}
    </StyledEResetFiltersButton>
  );
};
//#endregion
